(() => {
  const initialize = (root) => root.querySelectorAll('[data-bt-optin]').forEach((form) => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const preview = form.dataset.btPreview === 'true';
    const status = form.querySelector('[data-bt-status]');
    const button = form.querySelector('[type=submit]');
    const label = form.querySelector('[data-bt-submit-label]');
    const phone = form.elements.phone;
    const sms = form.elements.smsConsent;
    const phoneController = window.BecomingPhoneInput?.initialize(form);
    const validatePhone = () => {
      phone.required = sms.checked;
      phone.setCustomValidity(sms.checked && !phoneController?.getNumber() ? 'For SMS, choose your country and enter a complete phone number.' : '');
    };
    phone.addEventListener('invalid', () => { form.querySelector('.bt-sms-options').open = true; });
    sms.addEventListener('change', validatePhone);
    phone.addEventListener('input', validatePhone);
    form.elements.phoneCountry.addEventListener('change', validatePhone);
    button.disabled = !preview && !form.dataset.endpoint;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.getAttribute('aria-busy') === 'true') return;
      status.hidden = true;
      validatePhone();
      if (!form.reportValidity()) return;
      if (preview) {
        status.textContent = 'Preview: Thanks for signing up. No subscription has been saved.';
        status.hidden = false; status.focus(); return;
      }
      if (!form.dataset.endpoint) return;
      button.disabled = true; label.textContent = 'Submitting…'; form.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 55000);
      try {
        const response = await fetch(form.dataset.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, signal: controller.signal,
          body: JSON.stringify({ email: form.elements.email.value.trim(), emailConsent: form.elements.emailConsent.checked,
            phone: sms.checked ? phoneController.getNumber() : '', smsConsent: sms.checked, website: form.elements.website.value }),
        });
        const result = await response.json();
        if (!response.ok || result.success !== true) throw new Error(result.error || 'We couldn’t confirm your signup. Please try again.');
        status.classList.remove('bt-status--error');
        status.textContent = sms.checked ? 'You’re in. You’re subscribed to email and SMS updates.' : 'You’re in. You’re subscribed to email updates.';
        form.reset(); validatePhone();
      } catch (error) {
        status.classList.add('bt-status--error');
        status.textContent = error.name === 'AbortError' ? 'We couldn’t confirm your signup in time. Please try again.' : error.message;
      } finally {
        clearTimeout(timeout); button.disabled = false; label.textContent = 'Get first access'; form.removeAttribute('aria-busy');
        status.hidden = false; status.focus();
      }
    });
  });
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
